import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    invoiceSymbol,
    numberOfRegistrations,
    name,
    from,
    to,
    dayActive,
    invoiceSample,
    supplierName,
    supplierTaxCode,
  },
} = checkout;

const validations = Yup.object().shape({
  [invoiceSymbol.name]: Yup.string().required(invoiceSymbol.errorMsg),
  [invoiceSample.name]: Yup.string().required(invoiceSample.errorMsg),
  [supplierName.name]: Yup.string().required(supplierName.errorMsg),
  [supplierTaxCode.name]: Yup.string().required(supplierTaxCode.errorMsg),
  [numberOfRegistrations.name]: Yup.string().required(numberOfRegistrations.errorMsg),
  [name.name]: Yup.string().required(name.errorMsg),
  [from.name]: Yup.string().required(from.errorMsg),
  [to.name]: Yup.string().required(to.errorMsg),
  [dayActive.name]: Yup.string().required(dayActive.errorMsg),
});

export default validations;
